var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [_vm._v(" 对账时间区间选择不能超过3个月 ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }